// extracted by mini-css-extract-plugin
module.exports = {"valueSection__items":"value-section_valueSection__items__w1e9_","valueSection__item":"value-section_valueSection__item__60o2c"};